
		<ng-container #modalContent></ng-container>
  


// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/ui/modal/modal.component.ts.ModalComponent.html